export const ru = {
    'call-already-exists-error': 'Звонок для встречи уже существует',
};
